<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="!everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="everythingLoaded"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>schedule</md-icon>
          </div>
          <h4 class="title">Roosters</h4>
        </md-card-header>
        <md-card-content>
          <md-checkbox v-model="includeArchived"
            >Toon gearchiveerde roosters</md-checkbox
          >

          <md-table
            v-if="everythingLoaded"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Roosters per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek roosters(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Status"
                md-sort-by="status"
              >
                {{ getStatusLabel(item.status) }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Jaar"
                md-sort-by="year"
              >
                {{ item.year }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Week"
                md-sort-by="week"
              >
                {{ item.week }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Start datum"
                md-sort-by="startDate"
              >
                {{ formatDate(item.startDate) }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Stop datum"
                md-sort-by="stopDate"
              >
                {{ formatDate(item.stopDate) }}
              </md-table-cell>
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Tijd"
              >
                {{ calculateTime(item.startDate, item.stopDate) }}
              </md-table-cell>
              <md-table-cell md-label="Acties">
                <div class="md-group">
                  <md-button
                    class="md-just-icon md-danger md-simple"
                    @click.native="handleDelete(item)"
                  >
                    <md-icon>delete</md-icon>
                  </md-button>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions v-if="everythingLoaded" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van {{ total }} roosters
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableDataFiltered;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDataFiltered.length;
    },
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    tableDataFiltered: function() {
      var data = [];
      for (var i in this.tableData) {
        if (
          this.includeArchived === false &&
          this.getTimestampForStopDate(this.tableData[i].stopDate) <
            this.timestampNow
        ) {
          continue;
        }

        data.push(this.tableData[i]);
      }

      return this.sortAll(data);
    }
  },
  data() {
    return {
      currentSort: "startDate",
      currentSortOrder: "desc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      footerTable: ["Naam", "Reserve", "Groep", "Volgorde", "Verwijderen"],
      searchQuery: "",
      propsToSearch: ["name", "group", "order"],
      tableData: [],
      searchedData: [],
      statuses: [],
      fuseSearch: null,
      timestampNow: 0,
      includeArchived: false,
      loaded: {
        schedules: false,
        statuses: false
      }
    };
  },
  methods: {
    loadSchedules() {
      this.loaded.schedules = false;
      this.$http.get(this.$apiBaseUrl + "schedules").then(
        response => {
          this.loaded.schedules = true;
          let tableData = response.data.schedules;

          for (var i in tableData) {
            tableData[i].startDate = tableData[i].dates[1];
            tableData[i].stopDate = tableData[i].dates[7];
          }

          this.tableData = tableData;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableDataFiltered, {
            keys: ["name", "group", "order"],
            threshold: 0.3
          });
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van roosters",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    loadSchedulesStatuses() {
      this.loaded.statuses = false;
      this.$http.get(this.$apiBaseUrl + "schedules/statuses").then(
        response => {
          this.loaded.statuses = true;
          this.statuses = response.data.scheduleStatuses;
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van roosters",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    handleEdit(item) {
      this.$router.push("/schedules/edit/" + item.id);
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Rooster "${item.year} week ${item.week}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http.delete(this.$apiBaseUrl + "schedules/" + item.id).then(
            response => {
              this.deleteRow(item);

              this.notifyVue(
                "Rooster succesvol verwijderd",
                "check",
                "success",
                5000
              );

              // Fuse search initialization.
              this.fuseSearch = new Fuse(this.tableDataFiltered, {
                keys: ["name", "group", "order"],
                threshold: 0.3
              });
            },
            response => {
              if (response.status === 403) {
                this.notifyVue(
                  "U heeft geen rechten voor het beheren van roosters",
                  "add_alert",
                  "danger",
                  0
                );
              }
            }
          );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    getStatusLabel(status) {
      return this.statuses[status].label;
    },
    getClientTimezoneOffset() {
      return Math.round(new Date().getTimezoneOffset() / 60);
    },
    updateTimestampNow() {
      this.timestampNow = Math.floor(Date.now() / 1000);
    },
    getTimestampForStartDate(date) {
      return Math.floor(new Date(date + "T00:00:00.000+0200").getTime() / 1000);
    },
    getTimestampForStopDate(date) {
      return Math.floor(new Date(date + "T23:59:59.999+0200").getTime() / 1000);
    },
    calculateTime(startDate, stopDate) {
      var startDateTime = this.getTimestampForStartDate(startDate);
      var stopDateTime = this.getTimestampForStopDate(stopDate);

      if (this.timestampNow < startDateTime) {
        return (
          "Over " + this.labelTimePeriod(startDateTime - this.timestampNow)
        );
      } else if (this.timestampNow > stopDateTime) {
        return (
          this.labelTimePeriod(this.timestampNow - stopDateTime) + " geleden"
        );
      } else {
        return "Huidige week";
      }
    },
    labelTimePeriod(time) {
      if (time < 60) {
        return (
          time +
          this.labelTimePeriodSingleMultiple(time, " seconde", " seconden")
        );
      } else if (time < 3600) {
        return this.labelTimePeriodSingleMultiple(
          Math.floor(time / 60),
          " minuut",
          " minuten"
        );
      } else if (time < 86400) {
        return this.labelTimePeriodSingleMultiple(
          Math.floor(time / 3600),
          " uur",
          " uur"
        );
      } else if (time < 86400 * 7) {
        return this.labelTimePeriodSingleMultiple(
          Math.floor(time / 86400),
          " dag",
          " dagen"
        );
      } else if (time < 86400 * 7 * 5) {
        return this.labelTimePeriodSingleMultiple(
          Math.floor(time / (86400 * 7)),
          " week",
          " weken"
        );
      } else {
        return this.labelTimePeriodSingleMultiple(
          Math.floor(time / (86400 * 30.4)),
          " maand",
          " maanden"
        );
      }
    },
    labelTimePeriodSingleMultiple(value, singleLabel, multipleLabel) {
      if (value === 1 || value === "1") {
        return value + " " + singleLabel;
      }
      return value + " " + multipleLabel;
    },
    formatDate(date) {
      if (typeof date !== "string" || date === "") {
        return date;
      }
      date = date.split("-");
      if (date[0].length === 4) {
        date = date.reverse();
      }
      return date.join("-");
    }
  },
  created() {
    setInterval(this.updateTimestampNow, 1000);
  },
  mounted() {
    this.loadSchedules();
    this.loadSchedulesStatuses();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableDataFiltered;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
</style>
